import { createFileRoute } from "@tanstack/react-router";
import { PortalSettingsPage } from "@/features/portalmore/PortalSettingsPage";

/** Portal settings: the client's contacts (P109). */
export const Route = createFileRoute("/portal/settings")({
  component: PortalSettingsPage,
});
